import { Platform } from "react-native";

export const FixedPosition = (Platform.OS === "web" ? "fixed" : "absolute") as "absolute";

export const StickyPosition = (Platform.OS === "web" ? "sticky" : "relative") as "relative";
